(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    // Sleek mega-menu: hover/focus on left rail item swaps right panel
  (function () {
    const init = () => {
      document.querySelectorAll('[data-megamenu]').forEach((menu) => {
        if (menu.dataset.svxMegamenuBound === '1') return;
        menu.dataset.svxMegamenuBound = '1';
        const rails = menu.querySelectorAll('.svx-megamenu__rail-item');
        const panels = menu.querySelectorAll('.svx-megamenu__panel');
        // Service Areas only: also swap the intro media image to match the hovered county.
        const submenuPanel = menu.closest('.svx-submenu-panel');
        const mediaImgs = submenuPanel
          ? submenuPanel.querySelectorAll('.svx-submenu-panel__media--service-areas .svx-submenu-panel__media-img')
          : [];
        const activate = (target) => {
          rails.forEach((r) => r.classList.toggle('is-active', r.dataset.target === target));
          panels.forEach((p) => p.classList.toggle('is-active', p.dataset.target === target));
          mediaImgs.forEach((img) => img.classList.toggle('is-active', img.dataset.countyTarget === target));
        };
        rails.forEach((rail) => {
          const target = rail.dataset.target;
          if (!target) return;
          rail.addEventListener('mouseenter', () => activate(target));
          rail.addEventListener('focus', () => activate(target));
        });
        // Show the first county/category by default so the right panel is never empty
        const firstRail = rails[0];
        if (firstRail && firstRail.dataset.target) activate(firstRail.dataset.target);
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    // Re-bind on Shopify theme editor section reloads
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
